import { useQuery } from "react-query";
import { fetchForecastsData } from "./services/ForecastService";
import { useForecastStore } from "../viewModel/stores/forecastStore";
import { CACHE_TTL_MS } from "./ttl.cache";

export const useForecast = (options = {}) => {

  const { shouldFetchForecastData = false } = options;

  const setForecastData = useForecastStore((s) => s.setForecastData);

  return useQuery({
    queryKey: ["forecast"],
    queryFn: async () => {

      const results = await fetchForecastsData();

      return {
        latestForecast: results?.forecasts?.latestForecast,
        historicPredictionsToUse: results?.forecasts?.historicPredictions,
        initialSortBy: results?.initialSortBy?.initialSortBy,
      };
    },

    staleTime: CACHE_TTL_MS.TTL_6_HOURS,
    cacheTime: CACHE_TTL_MS.TTL_24_HOURS,
    refetchOnMount: false,
    enabled: shouldFetchForecastData,
    
    onSuccess: (data) => {
      setForecastData(data);
    },

    ...options,
  });
};